import { NavLink, useLocation } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { cn } from "../../lib/utils";

export default function KnowledgeBaseNavItem({ collapsed }) {
  const location = useLocation();
  const isActive = location.pathname === "/knowledge-base";

  return (
    <NavLink
      to="/knowledge-base"
      title={collapsed ? "Knowledge Base" : undefined}
      className={cn(
        "flex items-center transition-all duration-200 group relative",
        collapsed ? "justify-center mx-1 px-0 py-2.5 rounded-lg" : "gap-3 px-6 py-3 text-sm font-bold",
        isActive
          ? collapsed ? "bg-navy-700 text-white" : "bg-navy-700 text-white border-r-2 border-yellow-400"
          : "text-white hover:bg-yellow-500/20 hover:text-yellow-300"
      )}
      data-testid="nav-knowledge-base"
    >
      <GraduationCap className={cn("w-5 h-5 transition-colors", isActive ? "text-yellow-400" : "text-[#4D4DFF]")} strokeWidth={2} />
      {!collapsed && <span className="flex-1">Knowledge Base</span>}
    </NavLink>
  );
}
